exports = module.exports = require("../../../../employee/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".modal {\n  width: 100%;\n  padding: 0 8px;\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  z-index: 1101;\n  background: #010101;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n  overflow: hidden;\n  left: 0; }\n\n.modal-close-cont {\n  position: absolute;\n  top: 10px;\n  right: 10px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!../lib/egov-ui-kit/components/ImageModal/index.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!../lib/egov-ui-kit/components/ImageModal/index.css
// module chunks = 504